export default __webpack_public_path__ + "static/media/05_Lori_gorge.8f792bf3.webp";